/** Naming a move between two runs, and the band inside which there is no move. */

/**
 * The band inside which a move against the baseline is treated as noise. The
 * judges are stochastic, so a 0.05 wobble on a 1-4 mean is their own jitter and
 * flagging it would bury the real regressions.
 */
export const SCORE_DELTA_EPSILON = 0.1;

export const ComparisonVerdict = {
  IMPROVED: "improved",
  REGRESSED: "regressed",
  UNCHANGED: "unchanged",
  /** Judged in exactly one of the two runs, so no delta exists. */
  ADDED: "added",
  REMOVED: "removed",
} as const;

export type ComparisonVerdict = (typeof ComparisonVerdict)[keyof typeof ComparisonVerdict];

/**
 * The comparison filter chips, in the order a reviewer works them: regressions
 * first, because that is the question a comparison is opened to answer.
 */
export const COMPARISON_FILTER_ORDER = [
  ComparisonVerdict.REGRESSED,
  ComparisonVerdict.IMPROVED,
  ComparisonVerdict.UNCHANGED,
  ComparisonVerdict.ADDED,
  ComparisonVerdict.REMOVED,
] as const;

export const COMPARISON_VERDICT_CONFIG = {
  [ComparisonVerdict.REGRESSED]: { label: "Regressed", toneClass: "text-red-700" },
  [ComparisonVerdict.IMPROVED]: { label: "Improved", toneClass: "text-green-700" },
  [ComparisonVerdict.UNCHANGED]: { label: "Unchanged", toneClass: "text-muted-foreground" },
  [ComparisonVerdict.ADDED]: { label: "New", toneClass: "text-blue-700" },
  [ComparisonVerdict.REMOVED]: { label: "Dropped", toneClass: "text-muted-foreground" },
} as const satisfies Record<ComparisonVerdict, { label: string; toneClass: string }>;
